<div class="mainbox {{userClass}}" [formGroup]="group">
  <div [class.haserror-gotop]="isshow && f[name].touched && f[name]?.invalid"
       [class.gotop]="isshow"
       (focus)="focusFunction()"
       (click)="focusFunction();inp.click()"
       (focusout)="focusOutFunction()"
       class="label">
    <label class="txt" [class.lbl]="isshow"> {{label}} </label>
    <span [class.error]="f[name].touched && f[name]?.invalid" class="star" *ngIf="required"> * </span>
  </div>
  <div class="textareabox">
    <textarea rows="3"
              #inp
              (focus)="focusFunction()"
              (focusout)="focusOutFunction()"
              class="textarea"
              [class.hasborder]="isshow "
              [class.border]="isshow "
              id="{{name}}"
              [(ngClass)]="class"
              [formControl]="formControl()"
              name="{{name}}"
              maxlength="{{maxLength}}"
              min="{{min}}"
              max="{{max}}"
              minlength="{{minLength}}"
              [disabled]="disabled"
              numbersOnly digits="35" decimals="3"
              (ngModelChange)='onChange($event)'></textarea>
    <div class="hint unvisible" *ngIf="hint && !f[name].touched" [class.visible]="hint && !f[name].touched">
      <span>{{hint}}</span>
    </div>
    <div class="error unvisible" *ngIf="f[name].touched && f[name]?.invalid" [class.visible]="f[name].touched && f[name]?.invalid">
      <span *ngIf="f[name].errors?.required">
        {{label}} {{'Errors.Required'| translate}}
      </span>
      <span [hidden]="!f[name].errors?.pattern">
        {{label}} {{'Errors.Pattern' | translate}}
      </span>
      <span [hidden]="!f[name].errors?.minlength">
        {{('Errors.Minlength'| translate ).replace( '[0]' , label).replace( '[1]' , minLength) }}
      </span>
      <span [hidden]="!f[name].errors?.maxlength">
        {{('Errors.Maxlength'| translate ).replace( '[0]' , label).replace( '[1]' , maxLength) }}
      </span>
      <span [hidden]="!f[name].errors?.max">
        {{('Errors.Length'| translate ).replace( '[0]' , label).replace( '[1]' , min).replace( '[2]' , max) }}
      </span>
    </div>
  </div>
</div>
